<template>

	<!-- Billing Information Card -->
	<a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ paddingTop: 0, paddingBottom: '16px' }">
		<template #title>
			<h6 class="font-semibold m-0">出入金</h6>
		</template>
		<template #extra>
			<a-button size="small" @click="showModal">申请</a-button>
		</template>
		<a-row :gutter="[24, 24]">
			<a-col :span="6" v-for="(item, key) in logList" :key="key">
				<a-card :bordered="false" class="card-billing-info">
					<div class="col-info">
						<a-descriptions title="Oliver Liam" :column="1">
							<a-descriptions-item label="类 型">
								{{ item.type == 0 ? "出金" : "入金" }}
							</a-descriptions-item>
							<a-descriptions-item label="状 态">
								{{ item.status == 0 ? "申请" : (item.status == 1 ? "通过" : "拒绝") }}
							</a-descriptions-item>
							<a-descriptions-item label="金 额">
								<span class="text-danger">{{ "$" + item.amount }}</span>
							</a-descriptions-item>
							<a-descriptions-item label="提交时间">
								{{ moment(item.time).format("YYYY-MM-DD") }}
							</a-descriptions-item>
							<a-descriptions-item label="处理时间">
								{{ item.auditTime ? moment(item.auditTime).format("YYYY-MM-DD") : "" }}
							</a-descriptions-item>
						</a-descriptions>
					</div>
					<div class="col-action">
						<a-button type="link" size="small" @click="delModal(item.id)">
							<svg width="16" height="16" viewBox="0 0 20 20" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path class="fill-danger" fill-rule="evenodd" clip-rule="evenodd"
									d="M9 2C8.62123 2 8.27497 2.214 8.10557 2.55279L7.38197 4H4C3.44772 4 3 4.44772 3 5C3 5.55228 3.44772 6 4 6L4 16C4 17.1046 4.89543 18 6 18H14C15.1046 18 16 17.1046 16 16V6C16.5523 6 17 5.55228 17 5C17 4.44772 16.5523 4 16 4H12.618L11.8944 2.55279C11.725 2.214 11.3788 2 11 2H9ZM7 8C7 7.44772 7.44772 7 8 7C8.55228 7 9 7.44772 9 8V14C9 14.5523 8.55228 15 8 15C7.44772 15 7 14.5523 7 14V8ZM12 7C11.4477 7 11 7.44772 11 8V14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14V8C13 7.44772 12.5523 7 12 7Z"
									fill="#111827" />
							</svg>
							<span class="text-danger"></span>
						</a-button>
						<a-button type="link" size="small" @click="updateModal(item)">
							<svg width="16" height="16" viewBox="0 0 20 20" fill="none"
								xmlns="http://www.w3.org/2000/svg">
								<path class="fill-muted"
									d="M13.5858 3.58579C14.3668 2.80474 15.6332 2.80474 16.4142 3.58579C17.1953 4.36683 17.1953 5.63316 16.4142 6.41421L15.6213 7.20711L12.7929 4.37868L13.5858 3.58579Z"
									fill="#111827" />
								<path class="fill-muted"
									d="M11.3787 5.79289L3 14.1716V17H5.82842L14.2071 8.62132L11.3787 5.79289Z"
									fill="#111827" />
							</svg>
							<span class="text-dark"></span>
						</a-button>
					</div>
				</a-card>
			</a-col>

		</a-row>

		<a-modal v-model="visible" :title="title" on-ok="handleOk">
			<template slot="footer">
				<a-button key="back" @click="handleCancel">
					返回
				</a-button>
				<a-button key="submit" type="primary" :loading="loading" @click="handleOk">
					提交
				</a-button>
			</template>
			<div style="margin-bottom: 10px;">
				<a-row type="flex" align="middle">
					<a-col :span="4" :md="4" style="display: flex; align-items: center; justify-content: center">
						<div style="font-weight: 600;">申请类型
						</div>
					</a-col>
					<a-col :span="20" :md="20">
						<a-radio-group v-model="info.type">
							<a-radio-button :value=0>
								出金
							</a-radio-button>
							<a-radio-button :value=1>
								入金
							</a-radio-button>
						</a-radio-group>
					</a-col>
				</a-row>
			</div>
			<div style="margin-bottom: 10px;">
				<a-row type="flex" align="middle">
					<a-col :span="4" :md="4" style="display: flex; align-items: center; justify-content: center">
						<div style="font-weight: 600;">金额
						</div>
					</a-col>
					<a-col :span="20" :md="20">
						<a-input-number v-model="info.amount" :min="0" :precision="0" :step="100"
							:formatter="value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
							:parser="value => value.replace(/\$\s?|(,*)/g, '')" />
					</a-col>
				</a-row>
			</div>
			<div style="margin-bottom: 10px;" v-if="info.type == 0 && eInfo.cardNo.length == 0">
				<a-row type="flex" align="middle">
					<a-col :span="4" :md="4" style="display: flex; align-items: center; justify-content: center">
						<div style="font-weight: 600;">银行卡号
						</div>
					</a-col>
					<a-col :span="20" :md="20">
						<a-input v-model="info.info.bankCardNo" placeholder="" />
					</a-col>
				</a-row>
			</div>
			<div style="margin-bottom: 10px;" v-if="info.type == 0 && eInfo.cardNo.length == 0">
				<a-row type="flex" align="middle">
					<a-col :span="4" :md="4" style="display: flex; align-items: center; justify-content: center">
						<div style="font-weight: 600;">银行名称
						</div>
					</a-col>
					<a-col :span="20" :md="20">
						<a-input v-model="info.info.bankName" placeholder="" />
					</a-col>
				</a-row>
			</div>
			<div style="margin-bottom: 10px;" v-if="info.type == 1">
				<a-row type="flex" align="middle">
					<a-col :span="4" :md="4" style="display: flex; align-items: center; justify-content: center">
						<div style="font-weight: 600;">转账截图
						</div>
					</a-col>
					<a-col :span="20" :md="20">
						<ImageUpload v-model="imgId" :limit='3' :fileType="fileType" />
					</a-col>
				</a-row>
			</div>
			<div style="margin-bottom: 10px;">
				<a-row type="flex" align="middle">
					<a-col :span="4" :md="4" style="display: flex; align-items: center; justify-content: center">
						<div style="font-weight: 600;">备注
						</div>
					</a-col>
					<a-col :span="20" :md="20">
						<a-textarea v-model="info.remark" placeholder="备注" :auto-size="{ minRows: 2, maxRows: 6 }" />
					</a-col>
				</a-row>
			</div>
		</a-modal>
	</a-card>
	<!-- / Billing Information Card -->

</template>

<script>
import ImageUpload from '../../components/ImageUpload'
import { getFinanciallog, upUserFinanciallog, editUserFinanciallog, delUserFinanciallog } from '../../utils/user';
import { successNotification, warnNotification } from '../../utils/util';
import { Modal } from 'ant-design-vue';
import moment from 'moment';

export default ({
	components: {
		ImageUpload,
	},
	data() {
		return {
			moment,
			loading: false,
			visible: false,
			title: "",
			fileType: ['png', 'jpg', 'jpeg'],
			logList: [],
			imgId: '',
			eInfo: { cardNo: [], pic: "" },
			info: { amount: 0, type: 0, status: 0, remark: "", info: "" },
		}
	},
	mounted: function () {
		this.userInfo = JSON.parse(window.sessionStorage.getItem("userInfo"));
		this.getLog();
	},
	methods: {
		getLog() {
			let params = { status: 0 };
			getFinanciallog(params).then(data => {
				if (data.code === 0) {
					this.logList = data.list;
				} else {
					warnNotification("失败", data.msg);
				}
			})
				.catch(err => {
					console.info("err:", err)
					this.loading = false;
				})
		},
		updateModal(item) {
			this.info = item
			this.imgId = JSON.parse(this.info.info).pic
			if (this.userInfo.financialInfo) {
				this.eInfo.cardNo = this.userInfo.financialInfo;
			}
			this.title = "修改出入金申请";
			this.visible = true;
		},
		delModal(id) {
			let _that = this;
			Modal.confirm({
				title: '确认删除该申请吗？',
				content: '一旦删除，您将无法恢复。',
				okText: '确认',
				cancelText: '取消',
				onOk() {
					let ids = []
					ids.push(id);
					delUserFinanciallog(ids).then(data => {
						if (data.code === 0) {
							successNotification("成功", "删除成功");
							_that.getLog();
						} else {
							warnNotification("失败", data.msg);
						}
					})
						.catch(err => {
							console.info("err:", err)
						})
				},
				onCancel() {
					console.log('取消了操作');
				},
			});
		},
		showModal() {
			this.info = { amount: 0, type: 0, status: 0, remark: "", info: "" };
			if (this.userInfo.financialInfo) {
				this.eInfo.cardNo = this.userInfo.financialInfo;
			}
			this.title = "出入金申请";
			this.visible = true;
		},
		handleOk(e) {
			this.loading = true;
			this.eInfo.pic = this.imgId
			this.info.info = JSON.stringify(this.eInfo)
			if (this.info.id) {
				editUserFinanciallog(JSON.stringify(this.info)).then(data => {
					if (data.code === 0) {
						successNotification("成功", "提交成功");
						setTimeout(() => {
							this.getLog();
							this.visible = false;
							this.loading = false;
							this.handleCancel()
						}, 100);
					} else {
						warnNotification("失败", data.msg);
					}
				})
					.catch(err => {
						console.info("err:", err)
						this.loading = false;
					})
			} else {
				upUserFinanciallog(JSON.stringify(this.info)).then(data => {
					if (data.code === 0) {
						successNotification("成功", "提交成功");
						setTimeout(() => {
							this.getLog();
							this.visible = false;
							this.loading = false;
							this.handleCancel()
						}, 100);
					} else {
						warnNotification("失败", data.msg);
					}
				})
					.catch(err => {
						console.info("err:", err)
						this.loading = false;
					})
			}

		},
		handleCancel(e) {
			this.info = { amount: "", type: "", status: 0, remark: "", info: "" };
			this.title = "";
			this.imgId = "";
			this.eInfo = { cardNo: [], pic: "" };
			this.visible = false;
		},
	}
})

</script>